// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottom[data-v-5e64eea4] {\n  position: fixed;\n  bottom: 10%;\n  width: calc(100% - 32px);\n  left: 16px;\n  right: 16px;\n  z-index: 9998;\n  height: 200px;\n  -webkit-filter: opacity(0.9);\n          filter: opacity(0.9);\n}\n[data-v-5e64eea4] .el-alert__description {\n  font-size: 40px;\n  color: #f56c6c !important;\n}", ""]);
// Exports
module.exports = exports;
